import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as v, S as p } from "./icons.types-0722eef5.js";
function g({ title: r, titleId: n, size: i, width: o, height: s, extended: e = !1, ...a }) {
  const c = e ? v : p, h = i ? c[i] : o || c[e ? "s" : "l"], t = i ? c[i] : s || c[e ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: h,
      height: t,
      "aria-labelledby": n,
      ...a,
      children: [
        r ? /* @__PURE__ */ l("title", { id: n, children: r }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Map_view_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M25.368 1.5c.208.01.41.046.603.107l20.726 6.207 1.727-.573 14.681-4.336C67.028 1.746 70.5 4.246 70.5 8.277v51.356c0 2.266-1.639 4.447-3.863 5.11l-14.86 4.426-4.37 1.233c-.13.04-.264.067-.402.083l-.068.007c-.095.009-.191.011-.289.007h-.017a2.306 2.306 0 0 1-.595-.105l-20.769-6.119L8.83 69.173c-3.463.95-7.136-1.42-7.322-5l-.007-.285V12.514c0-2.374 1.485-4.318 3.991-5.272l19.103-5.644c.185-.056.38-.09.578-.097h.196Zm39.06 5.739-14.606 4.313-.789.26v53.42l1.445-.404 14.826-4.417c.28-.084.596-.503.596-.778V8.277c0-.981-.484-1.33-1.472-1.038Zm-36.861-.423v53.411l16.866 4.97V11.862L27.567 6.816Zm-4.6-.016L6.989 11.516c-.637.245-.889.574-.889.997V63.89c0 .618.76 1.126 1.444.939l15.423-4.598V6.8Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Map_view_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as MapView
};
